import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

const TodaysReservations = ({ reservationData, ...props }) => {
  const navigate = useNavigate();
  const { branchUseYn, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );
  const disabled = branchUseYn === "Y" && seqPartnerBranch === 0;

  const sections = [
    {
      key: "appointments",
      label: "개인",
      className: "",
      value: reservationData.appointmentCount,
    },
    {
      key: "group",
      label: "그룹",
      className: "orange",
      value: reservationData.classCount,
    },
    { key: "ot", label: "OT", className: "", value: reservationData.otCount },
    {
      key: "consulting",
      label: "상담",
      className: "",
      value: reservationData.consultingCount,
    },
    {
      key: "others",
      label: "기타",
      className: "gray",
      value: reservationData.etcCount,
    },
  ];

  const renderSections = () => {
    return sections.map((section) => {
      return (
        <OneStatWrapper key={section.key} disabled={disabled}>
          <StatTitle className={section.className} disabled={disabled}>
            {section.label}
          </StatTitle>
          <StatCount disabled={disabled}>
            {disabled ? 0 : section.value ? section.value : 0}
          </StatCount>
        </OneStatWrapper>
      );
    });
  };

  const handleClick = () => {
    if (disabled) return null;
    return navigate("/schedule");
  };

  return (
    <MainWrapper onClick={handleClick}>
      <CardTitleContainer>
        <Title disabled={disabled}>오늘의 예약</Title>
        <RightArrow size="S" />
      </CardTitleContainer>

      <StatsContainer>{renderSections()}</StatsContainer>
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 12px;
  height: 144px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const CardTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) =>
    props.disabled ? "#D4D9E3" : props.theme.colors.primaryTextColor};
`;

const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 18px;
`;

const OneStatWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatTitle = styled.div`
  padding: 4px 10px;
  border-radius: 24px;
  background-color: ${(props) =>
    props.disabled ? "#F0F3F9" : props.theme.colors.cardPurpleBackground};
  color: ${(props) =>
    props.disabled ? "#D4D9E3" : props.theme.colors.cardPurpleText};
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.2px;
  margin-bottom: 6px;

  ${(props) =>
    !props.disabled
      ? css`
          &.orange {
            background-color: ${(props) =>
              props.theme.colors.cardOrangeBackground};
            color: ${(props) => props.theme.colors.cardOrangeText};
          }

          &.gray {
            background-color: #f2f2f4;
            color: #626262;
          }
        `
      : ""}
`;

const StatCount = styled.p`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.2px;
  color: ${(props) => (props.disabled ? "#D4D9E3" : "#26282B")};
`;

TodaysReservations.propTypes = {
  reservationData: PropTypes.object,
  onClick: PropTypes.func,
};

export default TodaysReservations;
